export default {
  isConnected: state => state.isConnected,
  isConnecting: state => state.isConnecting,
  getLogs: state => () => state.logMessages, // Vuex does not react when editing dictionaries, so we force load it
  getErrorMessage: state => state.socketErrorMessage,
  isFetchingLogs: state => state.isFetchingLogs,
  isReceivingEvents: state => state.isReceivingEvents,
  hasFetchedLogs: state => state.hasFetchedLogs,
};
